import { create } from 'zustand';

type UseDoctor = {
  medcenterId: number | null;
  doctorId: number | null;
  doctorName: string;
  medcenterName: string;

  setMedcenterId: (id: number) => void;
  setDoctorId: (id: number) => void;
  setDoctorName: (name: string) => void;
  setMedcenterName: (name: string) => void;

  resetData: () => void;
};

export const useDoctor = create<UseDoctor>()(set => ({
  medcenterId: null,
  doctorId: null,
  doctorName: '',
  medcenterName: 'no_medcenter',

  setMedcenterId: (id: number) => {
    set({ medcenterId: id });
  },

  setDoctorId: (id: number) => {
    set({ doctorId: id });
  },

  setDoctorName: (name: string) => {
    set({ doctorName: name });
  },

  setMedcenterName: (name: string) => {
    set({ medcenterName: name });
  },

  resetData: () => {
    set({
      doctorId: null,
      doctorName: '',
      medcenterId: null,
      medcenterName: '',
    });
  },
}));
